import React from "react";
import { Redirect } from "react-router-dom";

const PageNotFound = () => <Redirect to="/" />;

export default PageNotFound;
